import { Component } from '@angular/core'
import { MatBottomSheetRef } from '@angular/material/bottom-sheet'
import { OrderHistoryService } from '../../../../services/order-history.service'

@Component({
    selector: 'app-bottom-sheet-excluded-items',
    templateUrl: './excluded-items.component.html',
    styleUrls: ['./excluded-items.component.scss'],
    standalone: false
})
export class ExcludedItemsComponent {
  constructor(
    private sheetRef: MatBottomSheetRef<ExcludedItemsComponent>,
    public orderHistoryService: OrderHistoryService
  ) {}
}
